import { useMutation } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { ISupportTicket } from "../../interfaces";

export const useAddSupportTicket = () => {
    return useMutation({
        mutationFn: async (payload: ISupportTicket) => {
            const response = await httpService.post<ISupportTicket>(
                API_CONFIG.path.supportTickets,
                payload
            );
            return response;
        }
    });
};
